import { render, staticRenderFns } from "./AfaPrescrizioniEserciziListComponent.vue?vue&type=template&id=3a3b3807&scoped=true"
import script from "./AfaPrescrizioniEserciziListComponent.vue?vue&type=script&lang=js"
export * from "./AfaPrescrizioniEserciziListComponent.vue?vue&type=script&lang=js"
import style0 from "./AfaPrescrizioniEserciziListComponent.vue?vue&type=style&index=0&id=3a3b3807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b3807",
  null
  
)

export default component.exports